import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import hooks from '@g4/automation-hooks';

/** @visibleName Radio Group */
export default class RadioGroup extends PureComponent {
  constructor(props) {
    super(props);

    let selected = '';
    const { value, defaultSelected } = props;

    if (typeof value !== 'undefined') {
      selected = value;
    } else if (typeof defaultSelected !== 'undefined') {
      selected = defaultSelected;
    }

    React.Children.forEach(props.children, child => {
      if (typeof child.props.checked === 'boolean' && child.props.checked) {
        selected = child.props.value;
      }
    });

    this.state = {
      selected: selected,
    };
  }

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any,
    defaultSelected: PropTypes.any,
    toRef: PropTypes.func,
    automationHook: PropTypes.string,
  };

  static defaultProps = {
    toRef: Function.prototype,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    var selected;

    /* istanbul ignore else */
    if (Object.prototype.hasOwnProperty.call(nextProps, 'value')) {
      selected = nextProps.value;
    }

    if (Object.prototype.hasOwnProperty.call(nextProps, 'children')) {
      React.Children.forEach(nextProps.children, child => {
        if (typeof child.props.checked === 'boolean' && child.props.checked) {
          selected = child.props.value;
        }
      });
    }
    if (typeof selected !== 'undefined') {
      this.setState({
        selected: selected,
      });
    }
  }

  handleChange = (event, selected) => {
    if (selected !== this.state.selected) {
      this.setState({ selected });

      if (this.props.onChange) {
        this.props.onChange(selected);
      }
    }
  };

  render() {
    return (
      <div
        {...hooks.hook(this.props.automationHook)}
        ref={this.props.toRef}
        className={this.props.className}
      >
        {React.Children.map(this.props.children, radio => {
          return (
            <radio.type
              {...radio.props}
              key={radio.props.value}
              value={radio.props.value}
              checked={radio.props.value === this.state.selected}
              name={this.props.name}
              onChange={this.handleChange}
              checkedIconAltAttribute={radio.props.checkedIconAltAttribute}
            />
          );
        })}
      </div>
    );
  }
}
